/**
 * 版本号对比，目前仅针对形如'1.0.0'的两个数字版本号
 * @param pre 版本号
 * @param next 版本号
 * @returns result 0为相等，-1为前小后大，1为前大后小
 */
export default function compareVersion(pre: string, next: string) {
    // 输入形如'1.0.0'的两个数字版本号
    const preVer = String(pre).split('.');
    const nextVer = String(next).split('.');
    const maxL = Math.max(preVer.length, nextVer.length);
    for (let i = 0; i < maxL; i++) {
        let preVal = preVer.length > i ? Number(preVer[i]) : 0;
        let nextVal = nextVer.length > i ? Number(nextVer[i]) : 0;
        if (preVal < nextVal) return -1; // -1为前小后大
        if (preVal > nextVal) return 1; // 1为前大后小
    }
    return 0; // 0为两版本号相等
}
